// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export const ActiveSkillCast = __t.object("ActiveSkillCast", {
  entityId: __t.string(),
  skillId: __t.string(),
  targetEntityId: __t.option(__t.string()),
  targetX: __t.i32(),
  targetY: __t.i32(),
  startedTick: __t.i64(),
  resolveTick: __t.i64(),
});
export type ActiveSkillCast = __Infer<typeof ActiveSkillCast>;

export const ActiveZone = __t.object("ActiveZone", {
  zoneId: __t.string(),
  zoneType: __t.string(),
  skillId: __t.string(),
  sourceEntityId: __t.string(),
  instanceId: __t.string(),
  mapId: __t.string(),
  centerX: __t.i32(),
  centerY: __t.i32(),
  radius: __t.i32(),
  expiresAtTick: __t.i64(),
  damage: __t.i32(),
  strikesPerTurn: __t.u8(),
  statusDurationTicks: __t.i64(),
});
export type ActiveZone = __Infer<typeof ActiveZone>;

export const ActiveZoneViewData = __t.object("ActiveZoneViewData", {
  zoneId: __t.string(),
  zoneType: __t.string(),
  skillId: __t.string(),
  sourceEntityId: __t.string(),
  instanceId: __t.string(),
  mapId: __t.string(),
  centerX: __t.i32(),
  centerY: __t.i32(),
  radius: __t.i32(),
  expiresAtTick: __t.i64(),
});
export type ActiveZoneViewData = __Infer<typeof ActiveZoneViewData>;

export const AddToItemBarArgs = __t.object("AddToItemBarArgs", {
  inventoryId: __t.string(),
});
export type AddToItemBarArgs = __Infer<typeof AddToItemBarArgs>;

export const AdminMapSummary = __t.object("AdminMapSummary", {
  mapId: __t.string(),
  name: __t.string(),
  mapKind: __t.string(),
  gridType: __t.string(),
  width: __t.u32(),
  height: __t.u32(),
});
export type AdminMapSummary = __Infer<typeof AdminMapSummary>;

export const AppearanceDefinitionViewRow = __t.object("AppearanceDefinitionViewRow", {
  entityType: __t.string(),
  displayName: __t.string(),
});
export type AppearanceDefinitionViewRow = __Infer<typeof AppearanceDefinitionViewRow>;

export const BringPlayerHereArgs = __t.object("BringPlayerHereArgs", {
  query: __t.string(),
});
export type BringPlayerHereArgs = __Infer<typeof BringPlayerHereArgs>;

// The tagged union or sum type for the algebraic type `ChatChannel`.
export const ChatChannel = __t.enum("ChatChannel", {
  System: __t.unit(),
  Map: __t.string(),
  Friend: __t.unit(),
  Guild: __t.string(),
  Whisper: __t.string(),
});
export type ChatChannel = __Infer<typeof ChatChannel>;

export const ChatCleanupSchedule = __t.object("ChatCleanupSchedule", {
  scheduleId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
});
export type ChatCleanupSchedule = __Infer<typeof ChatCleanupSchedule>;

export const ChatCommandHelpRow = __t.object("ChatCommandHelpRow", {
  name: __t.string(),
  usage: __t.string(),
  description: __t.string(),
});
export type ChatCommandHelpRow = __Infer<typeof ChatCommandHelpRow>;

export const ChatMessage = __t.object("ChatMessage", {
  messageId: __t.u64(),
  senderId: __t.string(),
  senderName: __t.string(),
  get channel() {
    return ChatChannel;
  },
  channelType: __t.string(),
  mapId: __t.string(),
  instanceId: __t.string(),
  guildName: __t.string(),
  whisperTarget: __t.string(),
  text: __t.string(),
  timestamp: __t.timestamp(),
  tsVal: __t.u64(),
});
export type ChatMessage = __Infer<typeof ChatMessage>;

export const ChatViewRow = __t.object("ChatViewRow", {
  messageId: __t.u64(),
  senderId: __t.string(),
  senderName: __t.string(),
  get channel() {
    return ChatChannel;
  },
  text: __t.string(),
  timestamp: __t.timestamp(),
});
export type ChatViewRow = __Infer<typeof ChatViewRow>;

export const ChestInventory = __t.object("ChestInventory", {
  entryId: __t.string(),
  npcId: __t.string(),
  slotIndex: __t.i32(),
  itemId: __t.string(),
  quantity: __t.u32(),
  tradeable: __t.bool(),
  metadataJson: __t.string(),
});
export type ChestInventory = __Infer<typeof ChestInventory>;

export const ChunkModification = __t.object("ChunkModification", {
  modificationId: __t.string(),
  instanceId: __t.string(),
  chunkX: __t.i32(),
  chunkY: __t.i32(),
  tileX: __t.i32(),
  tileY: __t.i32(),
  terrainOverride: __t.string(),
  placedBy: __t.string(),
  placedAt: __t.timestamp(),
});
export type ChunkModification = __Infer<typeof ChunkModification>;

export const ClearIntentQueueArgs = __t.object("ClearIntentQueueArgs", {});
export type ClearIntentQueueArgs = __Infer<typeof ClearIntentQueueArgs>;

export const CurrentMapDefinitionView = __t.object("CurrentMapDefinitionView", {
  mapId: __t.string(),
  name: __t.string(),
  width: __t.u32(),
  height: __t.u32(),
  tilesBlob: __t.byteArray(),
  terrainBlob: __t.byteArray(),
  spawnPointsJson: __t.string(),
  mapKind: __t.string(),
  gridType: __t.string(),
  rulesJson: __t.string(),
  renderJson: __t.option(__t.string()),
  biomeJson: __t.option(__t.string()),
  backendJson: __t.option(__t.string()),
});
export type CurrentMapDefinitionView = __Infer<typeof CurrentMapDefinitionView>;

export const CurrentMapObjectView = __t.object("CurrentMapObjectView", {
  objectId: __t.string(),
  assetId: __t.string(),
  x: __t.i32(),
  y: __t.i32(),
  offsetX: __t.f32(),
  offsetY: __t.f32(),
  sizeMultiplier: __t.f32(),
  flipHorizontal: __t.bool(),
  flipVertical: __t.bool(),
  rotationSteps: __t.i32(),
  layer: __t.string(),
  sortOrder: __t.i32(),
});
export type CurrentMapObjectView = __Infer<typeof CurrentMapObjectView>;

export const CurrentMapPortalView = __t.object("CurrentMapPortalView", {
  portalId: __t.string(),
  mapId: __t.string(),
  x: __t.i32(),
  y: __t.i32(),
  destMapId: __t.string(),
  destX: __t.i32(),
  destY: __t.i32(),
  destMapKind: __t.string(),
});
export type CurrentMapPortalView = __Infer<typeof CurrentMapPortalView>;

export const DisconnectPlayerSessionArgs = __t.object("DisconnectPlayerSessionArgs", {
  query: __t.string(),
});
export type DisconnectPlayerSessionArgs = __Infer<typeof DisconnectPlayerSessionArgs>;

export const DisguiseState = __t.object("DisguiseState", {
  entityId: __t.string(),
  disguisedEntityType: __t.string(),
  appliedAtTick: __t.i64(),
});
export type DisguiseState = __Infer<typeof DisguiseState>;

export const EnqueueIntentArgs = __t.object("EnqueueIntentArgs", {
  intentId: __t.string(),
  instanceId: __t.string(),
  tickTarget: __t.i64(),
  payloadJson: __t.string(),
});
export type EnqueueIntentArgs = __Infer<typeof EnqueueIntentArgs>;

export const EntitiesRuntime = __t.object("EntitiesRuntime", {
  entityId: __t.string(),
  instanceId: __t.string(),
  mapId: __t.string(),
  entityClass: __t.string(),
  ownerCharacterId: __t.string(),
  entityType: __t.string(),
  playerId: __t.option(__t.string()),
  mobTypeId: __t.option(__t.u32()),
  displayName: __t.string(),
  mapX: __t.i32(),
  mapY: __t.i32(),
  prevMapX: __t.i32(),
  prevMapY: __t.i32(),
  rotation: __t.i16(),
  hp: __t.i32(),
  maxHp: __t.i32(),
  mana: __t.i32(),
  maxMana: __t.i32(),
  stamina: __t.i32(),
  maxStamina: __t.i32(),
  moveDistance: __t.i32(),
  viewRadius: __t.u32(),
  statusJson: __t.string(),
  skillsJson: __t.string(),
  tagsJson: __t.string(),
  cooldownsJson: __t.string(),
  queueJson: __t.string(),
  positionTile: __t.string(),
  statsBlob: __t.string(),
  speed: __t.u32(),
  stealthLevel: __t.i32(),
  sourceId: __t.string(),
  appearanceBaseEntityType: __t.string(),
  appearanceEffectiveEntityType: __t.string(),
  appearanceColorHex: __t.string(),
  appearanceAccessoriesJson: __t.string(),
});
export type EntitiesRuntime = __Infer<typeof EntitiesRuntime>;

export const EntityMapData = __t.object("EntityMapData", {
  entityId: __t.string(),
  entityClass: __t.string(),
  entityType: __t.string(),
  appearanceColorHex: __t.option(__t.string()),
  appearanceAccessoriesJson: __t.option(__t.string()),
  playerId: __t.option(__t.string()),
  mapX: __t.i32(),
  mapY: __t.i32(),
  prevMapX: __t.option(__t.i32()),
  prevMapY: __t.option(__t.i32()),
  rotation: __t.i16(),
  hp: __t.i32(),
  maxHp: __t.i32(),
  mana: __t.option(__t.i32()),
  maxMana: __t.option(__t.i32()),
  stamina: __t.i32(),
  maxStamina: __t.i32(),
  mobInventoryValue: __t.option(__t.i32()),
  mobInventoryItemsJson: __t.option(__t.string()),
});
export type EntityMapData = __Infer<typeof EntityMapData>;

export const EquipItemArgs = __t.object("EquipItemArgs", {
  slotName: __t.string(),
  inventoryId: __t.string(),
});
export type EquipItemArgs = __Infer<typeof EquipItemArgs>;

export const EquipmentSlotView = __t.object("EquipmentSlotView", {
  slotName: __t.string(),
  inventoryId: __t.string(),
  itemId: __t.string(),
  quantity: __t.u32(),
  tradeable: __t.bool(),
  metadataJson: __t.string(),
});
export type EquipmentSlotView = __Infer<typeof EquipmentSlotView>;

export const Friend = __t.object("Friend", {
  id: __t.u64(),
  sourcePlayerId: __t.string(),
  targetPlayerId: __t.string(),
});
export type Friend = __Infer<typeof Friend>;

export const FriendPresence = __t.object("FriendPresence", {
  playerId: __t.string(),
  displayName: __t.string(),
  isOnline: __t.bool(),
});
export type FriendPresence = __Infer<typeof FriendPresence>;

export const GameItem = __t.object("GameItem", {
  itemId: __t.string(),
  displayName: __t.string(),
  itemValue: __t.u32(),
  maxStack: __t.u32(),
  itemType: __t.string(),
  metadataJson: __t.string(),
  inCirculation: __t.u64(),
  createdAt: __t.timestamp(),
});
export type GameItem = __Infer<typeof GameItem>;

export const GameManagers = __t.object("GameManagers", {
  accountId: __t.string(),
  playerId: __t.string(),
  role: __t.string(),
});
export type GameManagers = __Infer<typeof GameManagers>;

export const GameRuntimeControl = __t.object("GameRuntimeControl", {
  singletonId: __t.u8(),
  isPaused: __t.bool(),
  updatedAt: __t.timestamp(),
  updatedByIdentity: __t.string(),
});
export type GameRuntimeControl = __Infer<typeof GameRuntimeControl>;

export const GameState = __t.object("GameState", {
  singletonId: __t.u8(),
  currentTick: __t.i64(),
  lastTickTime: __t.timestamp(),
});
export type GameState = __Infer<typeof GameState>;

export const GameTickConfig = __t.object("GameTickConfig", {
  singletonId: __t.u8(),
  intervalMs: __t.u32(),
  updatedAt: __t.timestamp(),
  updatedByIdentity: __t.string(),
});
export type GameTickConfig = __Infer<typeof GameTickConfig>;

export const GameTickSchedule = __t.object("GameTickSchedule", {
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
});
export type GameTickSchedule = __Infer<typeof GameTickSchedule>;

export const Guild = __t.object("Guild", {
  guildId: __t.u64(),
  name: __t.string(),
  ownerId: __t.string(),
});
export type Guild = __Infer<typeof Guild>;

export const GuildMember = __t.object("GuildMember", {
  playerId: __t.string(),
  guildId: __t.u64(),
  rank: __t.string(),
});
export type GuildMember = __Infer<typeof GuildMember>;

export const GuildMemberPresence = __t.object("GuildMemberPresence", {
  playerId: __t.string(),
  displayName: __t.string(),
  rank: __t.string(),
  isOnline: __t.bool(),
});
export type GuildMemberPresence = __Infer<typeof GuildMemberPresence>;

export const GuildPresence = __t.object("GuildPresence", {
  guildName: __t.string(),
  get members() {
    return __t.array(GuildMemberPresence);
  },
});
export type GuildPresence = __Infer<typeof GuildPresence>;

export const InstanceChannelMaintenanceSchedule = __t.object("InstanceChannelMaintenanceSchedule", {
  scheduleId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
});
export type InstanceChannelMaintenanceSchedule = __Infer<typeof InstanceChannelMaintenanceSchedule>;

export const IntentQueue = __t.object("IntentQueue", {
  intentId: __t.string(),
  characterId: __t.string(),
  instanceId: __t.string(),
  tickTarget: __t.i64(),
  payloadJson: __t.string(),
  validationStatus: __t.string(),
  resolvedTick: __t.i64(),
  receivedAt: __t.timestamp(),
});
export type IntentQueue = __Infer<typeof IntentQueue>;

export const InventoryAccessArgs = __t.object("InventoryAccessArgs", {
  playerId: __t.string(),
});
export type InventoryAccessArgs = __Infer<typeof InventoryAccessArgs>;

export const InventorySlotView = __t.object("InventorySlotView", {
  inventoryId: __t.string(),
  slotIndex: __t.i32(),
  itemId: __t.string(),
  quantity: __t.u32(),
  tradeable: __t.bool(),
  metadataJson: __t.string(),
});
export type InventorySlotView = __Infer<typeof InventorySlotView>;

export const ItemBar = __t.object("ItemBar", {
  playerId: __t.string(),
  items: __t.array(__t.string()),
});
export type ItemBar = __Infer<typeof ItemBar>;

export const ItemBarSlotView = __t.object("ItemBarSlotView", {
  barIndex: __t.i32(),
  inventoryId: __t.string(),
  itemId: __t.string(),
  quantity: __t.u32(),
  tradeable: __t.bool(),
  metadataJson: __t.string(),
});
export type ItemBarSlotView = __Infer<typeof ItemBarSlotView>;

export const ItemContainerSlot = __t.object("ItemContainerSlot", {
  slotId: __t.string(),
  containerId: __t.string(),
  slotIndex: __t.i32(),
  itemInstanceId: __t.string(),
});
export type ItemContainerSlot = __Infer<typeof ItemContainerSlot>;

export const ItemDefinitionAccessArgs = __t.object("ItemDefinitionAccessArgs", {
  playerId: __t.string(),
  itemIds: __t.array(__t.string()),
});
export type ItemDefinitionAccessArgs = __Infer<typeof ItemDefinitionAccessArgs>;

export const ItemInstance = __t.object("ItemInstance", {
  itemInstanceId: __t.string(),
  itemId: __t.string(),
  quantity: __t.u32(),
  tradeable: __t.bool(),
  metadataJson: __t.string(),
  createdAt: __t.timestamp(),
});
export type ItemInstance = __Infer<typeof ItemInstance>;

export const LoginArgs = __t.object("LoginArgs", {
  username: __t.string(),
  password: __t.string(),
});
export type LoginArgs = __Infer<typeof LoginArgs>;

export const MailboxItem = __t.object("MailboxItem", {
  mailId: __t.u64(),
  fromPlayerId: __t.string(),
  toPlayerId: __t.string(),
  msg: __t.string(),
  trade: __t.string(),
  read: __t.bool(),
  timeSent: __t.timestamp(),
});
export type MailboxItem = __Infer<typeof MailboxItem>;

export const MailboxUnreadCounts = __t.object("MailboxUnreadCounts", {
  unreadMessages: __t.u32(),
  unreadIncomingTrades: __t.u32(),
  hasAnyUnread: __t.bool(),
});
export type MailboxUnreadCounts = __Infer<typeof MailboxUnreadCounts>;

export const MailboxViewRow = __t.object("MailboxViewRow", {
  mailId: __t.u64(),
  fromPlayerId: __t.string(),
  fromDisplayName: __t.string(),
  toPlayerId: __t.string(),
  toDisplayName: __t.string(),
  msg: __t.string(),
  trade: __t.string(),
  read: __t.bool(),
  timeSent: __t.timestamp(),
});
export type MailboxViewRow = __Infer<typeof MailboxViewRow>;

export const MapAccessArgs = __t.object("MapAccessArgs", {
  playerId: __t.string(),
  mapIds: __t.array(__t.string()),
});
export type MapAccessArgs = __Infer<typeof MapAccessArgs>;

export const MapDefinition = __t.object("MapDefinition", {
  mapId: __t.string(),
  name: __t.string(),
  width: __t.u32(),
  height: __t.u32(),
  tilesBlob: __t.byteArray(),
  terrainBlob: __t.byteArray(),
  spawnPointsJson: __t.string(),
  mapKind: __t.string(),
  gridType: __t.string(),
  rulesJson: __t.string(),
  renderJson: __t.option(__t.string()),
  biomeJson: __t.option(__t.string()),
  backendJson: __t.option(__t.string()),
  createdAt: __t.timestamp(),
});
export type MapDefinition = __Infer<typeof MapDefinition>;

export const MapEvent = __t.object("MapEvent", {
  eventId: __t.string(),
  eventType: __t.string(),
  instanceId: __t.string(),
  mapId: __t.string(),
  sourceId: __t.string(),
  targetId: __t.string(),
  skillId: __t.string(),
  amount: __t.i32(),
  targetHp: __t.i32(),
  targetMaxHp: __t.i32(),
  sourceX: __t.i32(),
  sourceY: __t.i32(),
  targetX: __t.i32(),
  targetY: __t.i32(),
  tick: __t.i64(),
  createdAt: __t.timestamp(),
  snap: __t.bool(),
  payloadJson: __t.string(),
});
export type MapEvent = __Infer<typeof MapEvent>;

export const MapEventData = __t.object("MapEventData", {
  eventId: __t.string(),
  eventType: __t.string(),
  instanceId: __t.string(),
  mapId: __t.string(),
  sourceId: __t.string(),
  targetId: __t.string(),
  skillId: __t.string(),
  amount: __t.i32(),
  targetHp: __t.i32(),
  targetMaxHp: __t.i32(),
  sourceX: __t.i32(),
  sourceY: __t.i32(),
  targetX: __t.i32(),
  targetY: __t.i32(),
  snap: __t.bool(),
  payloadJson: __t.string(),
  tick: __t.i64(),
  createdAt: __t.timestamp(),
});
export type MapEventData = __Infer<typeof MapEventData>;

export const MapInstance = __t.object("MapInstance", {
  instanceId: __t.string(),
  mapId: __t.string(),
  channelId: __t.string(),
  status: __t.string(),
  playerCount: __t.u32(),
  maxPlayers: __t.u32(),
  lastPopulationChangeAt: __t.timestamp(),
  markedForDeleteAt: __t.option(__t.timestamp()),
  createdAt: __t.timestamp(),
});
export type MapInstance = __Infer<typeof MapInstance>;

export const MapObject = __t.object("MapObject", {
  objectId: __t.string(),
  mapId: __t.string(),
  assetId: __t.string(),
  x: __t.i32(),
  y: __t.i32(),
  offsetX: __t.f32(),
  offsetY: __t.f32(),
  sizeMultiplier: __t.f32(),
  flipHorizontal: __t.bool(),
  flipVertical: __t.bool(),
  rotationSteps: __t.i32(),
  layer: __t.string(),
  sortOrder: __t.i32(),
  createdAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type MapObject = __Infer<typeof MapObject>;

export const MapPortal = __t.object("MapPortal", {
  portalId: __t.string(),
  mapId: __t.string(),
  x: __t.i32(),
  y: __t.i32(),
  destMapId: __t.string(),
  destX: __t.i32(),
  destY: __t.i32(),
});
export type MapPortal = __Infer<typeof MapPortal>;

export const MobDefinitionViewRow = __t.object("MobDefinitionViewRow", {
  mobTypeId: __t.u32(),
  entityType: __t.string(),
  displayName: __t.string(),
  tagsJson: __t.string(),
  baseHp: __t.i32(),
  baseMana: __t.i32(),
  moveDistance: __t.i32(),
  viewRadius: __t.u32(),
  speed: __t.u32(),
});
export type MobDefinitionViewRow = __Infer<typeof MobDefinitionViewRow>;

// The tagged union or sum type for the algebraic type `MobMode`.
export const MobMode = __t.enum("MobMode", {
  Idle: __t.unit(),
  Alert: __t.unit(),
  Engaged: __t.unit(),
  Disengaging: __t.unit(),
  Fleeing: __t.unit(),
});
export type MobMode = __Infer<typeof MobMode>;

export const MobRuntime = __t.object("MobRuntime", {
  entityId: __t.string(),
  get mode() {
    return MobMode;
  },
  get outOfCombatState() {
    return OutOfCombatState;
  },
  homeX: __t.i32(),
  homeY: __t.i32(),
  noticeTargetId: __t.option(__t.string()),
  combatTargetId: __t.option(__t.string()),
  lastSeenX: __t.option(__t.i32()),
  lastSeenY: __t.option(__t.i32()),
  lastSeenTick: __t.option(__t.i64()),
  disengageStartedTick: __t.option(__t.i64()),
  detectionLevel: __t.i32(),
  nextThinkTick: __t.i64(),
  lastSkillId: __t.option(__t.string()),
  lastSkillTick: __t.option(__t.i64()),
  get pendingActionKind() {
    return PendingMobActionKind;
  },
  pendingSkillId: __t.option(__t.string()),
  pendingTargetEntityId: __t.option(__t.string()),
  pendingTargetX: __t.option(__t.i32()),
  pendingTargetY: __t.option(__t.i32()),
  pendingResolveTick: __t.option(__t.i64()),
  outOfCombatGoalX: __t.i32(),
  outOfCombatGoalY: __t.i32(),
  outOfCombatGoalUntilTick: __t.i64(),
  patrolPointIndex: __t.u32(),
  inventoryValue: __t.i32(),
  inventoryItemsJson: __t.string(),
});
export type MobRuntime = __Infer<typeof MobRuntime>;

export const MoveInventoryItemArgs = __t.object("MoveInventoryItemArgs", {
  inventoryId: __t.string(),
  targetSlotIndex: __t.i32(),
});
export type MoveInventoryItemArgs = __Infer<typeof MoveInventoryItemArgs>;

export const MoveInventoryToStorageArgs = __t.object("MoveInventoryToStorageArgs", {
  inventoryId: __t.string(),
  targetSlotIndex: __t.i32(),
});
export type MoveInventoryToStorageArgs = __Infer<typeof MoveInventoryToStorageArgs>;

export const MovePlayerToMapArgs = __t.object("MovePlayerToMapArgs", {
  query: __t.string(),
  mapId: __t.string(),
  mapX: __t.i32(),
  mapY: __t.i32(),
  rotation: __t.i16(),
});
export type MovePlayerToMapArgs = __Infer<typeof MovePlayerToMapArgs>;

export const MoveStorageItemArgs = __t.object("MoveStorageItemArgs", {
  storageId: __t.string(),
  targetSlotIndex: __t.i32(),
});
export type MoveStorageItemArgs = __Infer<typeof MoveStorageItemArgs>;

export const MoveStorageToInventoryArgs = __t.object("MoveStorageToInventoryArgs", {
  storageId: __t.string(),
  targetSlotIndex: __t.i32(),
});
export type MoveStorageToInventoryArgs = __Infer<typeof MoveStorageToInventoryArgs>;

export const MyAdminStatus = __t.object("MyAdminStatus", {
  role: __t.string(),
  isAdmin: __t.bool(),
  isSuperAdmin: __t.bool(),
});
export type MyAdminStatus = __Infer<typeof MyAdminStatus>;

export const MyPlayerData = __t.object("MyPlayerData", {
  playerId: __t.string(),
  accountId: __t.string(),
  displayName: __t.string(),
  guildName: __t.option(__t.string()),
  level: __t.u32(),
  xp: __t.u64(),
  currentInstanceId: __t.string(),
  currentMapId: __t.string(),
  channelId: __t.string(),
  mapX: __t.i32(),
  mapY: __t.i32(),
  prevMapX: __t.i32(),
  prevMapY: __t.i32(),
  rotation: __t.i16(),
  hp: __t.i32(),
  maxHp: __t.i32(),
  mana: __t.i32(),
  maxMana: __t.i32(),
  stamina: __t.i32(),
  maxStamina: __t.i32(),
  statusJson: __t.string(),
  queueJson: __t.string(),
  inventoryCapacity: __t.u32(),
  storageCapacity: __t.u32(),
  moveDistance: __t.i32(),
  viewRadius: __t.u32(),
  isOnline: __t.bool(),
  updatedAt: __t.timestamp(),
});
export type MyPlayerData = __Infer<typeof MyPlayerData>;

export const MySkillData = __t.object("MySkillData", {
  skillId: __t.string(),
  displayName: __t.string(),
  description: __t.string(),
  cooldownTicks: __t.i64(),
  staminaCost: __t.i32(),
  durationTicks: __t.i64(),
  castTimeTicks: __t.i64(),
  range: __t.i32(),
  damage: __t.i32(),
  radius: __t.i32(),
  emoji: __t.string(),
  inputsJson: __t.string(),
  tags: __t.array(__t.string()),
  metaChildrenJson: __t.string(),
  lastUsedTick: __t.i64(),
});
export type MySkillData = __Infer<typeof MySkillData>;

export const NpcRuntime = __t.object("NpcRuntime", {
  npcId: __t.string(),
  instanceId: __t.string(),
  mapId: __t.string(),
  x: __t.i32(),
  y: __t.i32(),
  npcType: __t.string(),
  metadataJson: __t.string(),
  despawnTick: __t.i64(),
  createdAt: __t.timestamp(),
});
export type NpcRuntime = __Infer<typeof NpcRuntime>;

// The tagged union or sum type for the algebraic type `OutOfCombatState`.
export const OutOfCombatState = __t.enum("OutOfCombatState", {
  Idle: __t.unit(),
  Roaming: __t.unit(),
  Patrolling: __t.unit(),
  Dormant: __t.unit(),
  ReturningHome: __t.unit(),
});
export type OutOfCombatState = __Infer<typeof OutOfCombatState>;

// The tagged union or sum type for the algebraic type `PendingMobActionKind`.
export const PendingMobActionKind = __t.enum("PendingMobActionKind", {
  None: __t.unit(),
  ResolveCast: __t.unit(),
});
export type PendingMobActionKind = __Infer<typeof PendingMobActionKind>;

export const PerfTickMetrics = __t.object("PerfTickMetrics", {
  tick: __t.i64(),
  recordedAt: __t.timestamp(),
  durationMeasurementMode: __t.string(),
  tickCadenceUs: __t.u64(),
  tickOverrunUs: __t.u64(),
  tickDurationUs: __t.u64(),
  activeInstanceCount: __t.u32(),
  dueIntentCount: __t.u32(),
  turnEntityGroupCount: __t.u32(),
  turnEntitiesScanned: __t.u32(),
  collectTurnEntitiesDurationUs: __t.u64(),
  collectTurnEntitiesRowMutations: __t.u32(),
  visibilityDurationUs: __t.u64(),
  visibilityObserverCount: __t.u32(),
  visibilityEntitiesScanned: __t.u32(),
  visibilityDistanceChecks: __t.u32(),
  visibilityReusedObserverCount: __t.u32(),
  visibilityReuseMissObserverChangedCount: __t.u32(),
  visibilityReuseMissInstanceChangedCount: __t.u32(),
  visibilityVisibleEntities: __t.u32(),
  visibilityVisiblePlayers: __t.u32(),
  visibilityExitedEntities: __t.u32(),
  visibilityExitedPlayers: __t.u32(),
  visibilitySnapshotObservers: __t.u32(),
  visibilitySnapshotPlayerIds: __t.u32(),
  visibilitySnapshotEntityIds: __t.u32(),
  currentMapRuntimeEntitiesCalls: __t.u32(),
  currentMapRuntimeEntitiesCachedCalls: __t.u32(),
  currentMapRuntimeEntitiesFallbackCalls: __t.u32(),
  currentMapRuntimeEntitiesCandidateEntities: __t.u32(),
  currentMapRuntimeEntitiesRowsBuilt: __t.u32(),
  currentMapRuntimeEntitiesDistanceChecks: __t.u32(),
  currentMapRuntimeEntitiesPayloadBytes: __t.u64(),
  currentMapRuntimeEntitiesIdentityPayloadBytes: __t.u64(),
  currentMapRuntimeEntitiesAppearancePayloadBytes: __t.u64(),
  currentMapRuntimeEntitiesStatPayloadBytes: __t.u64(),
  entityMapDataConstructions: __t.u32(),
  visiblePlayersCalls: __t.u32(),
  visiblePlayersCachedRows: __t.u32(),
  visiblePlayersRowsBuilt: __t.u32(),
  visiblePlayersRowsReturned: __t.u32(),
  visiblePlayerIdentityCalls: __t.u32(),
  visiblePlayerIdentityCachedRows: __t.u32(),
  visiblePlayerIdentityRowsBuilt: __t.u32(),
  visiblePlayerIdentityRowsReturned: __t.u32(),
  visiblePlayerIdentityPayloadBytes: __t.u64(),
  myPlayerCalls: __t.u32(),
  myPlayerRowsBuilt: __t.u32(),
  myPlayerQueueJsonCalls: __t.u32(),
  myPlayerQueueJsonBytes: __t.u64(),
  cleanupOldEventsDurationUs: __t.u64(),
  cleanupOldEventsDeleted: __t.u32(),
  processActiveZonesDurationUs: __t.u64(),
  activeZoneInstances: __t.u32(),
  activeZoneCount: __t.u32(),
  activeZoneExpiredDeletions: __t.u32(),
  activeZoneInvalidMapDeletions: __t.u32(),
  activeZoneEffectTargets: __t.u32(),
  rowMutationProxyCount: __t.u32(),
});
export type PerfTickMetrics = __Infer<typeof PerfTickMetrics>;

export const PersistTickArgs = __t.object("PersistTickArgs", {
  tickId: __t.string(),
  instanceId: __t.string(),
  sequence: __t.u32(),
  eventsJson: __t.string(),
  entitiesSnapshotJson: __t.string(),
  hashChainPrev: __t.string(),
});
export type PersistTickArgs = __Infer<typeof PersistTickArgs>;

export const PlaceNpcArgs = __t.object("PlaceNpcArgs", {
  mapId: __t.string(),
  worldX: __t.i32(),
  worldY: __t.i32(),
  npcType: __t.string(),
  metadataJson: __t.string(),
});
export type PlaceNpcArgs = __Infer<typeof PlaceNpcArgs>;

export const PlacedNpc = __t.object("PlacedNpc", {
  npcId: __t.string(),
  mapId: __t.string(),
  worldX: __t.i32(),
  worldY: __t.i32(),
  npcType: __t.string(),
  width: __t.u32(),
  height: __t.u32(),
  metadataJson: __t.string(),
  placedBy: __t.string(),
  placedAt: __t.timestamp(),
});
export type PlacedNpc = __Infer<typeof PlacedNpc>;

export const PlayerAppearanceProfile = __t.object("PlayerAppearanceProfile", {
  playerId: __t.string(),
  baseEntityType: __t.string(),
  colorHex: __t.string(),
  accessoriesJson: __t.string(),
});
export type PlayerAppearanceProfile = __Infer<typeof PlayerAppearanceProfile>;

export const PlayerChestAccess = __t.object("PlayerChestAccess", {
  playerId: __t.string(),
  npcId: __t.string(),
});
export type PlayerChestAccess = __Infer<typeof PlayerChestAccess>;

export const PlayerEquipmentSlot = __t.object("PlayerEquipmentSlot", {
  slotId: __t.string(),
  playerId: __t.string(),
  slotName: __t.string(),
  inventoryId: __t.string(),
  equippedAt: __t.timestamp(),
});
export type PlayerEquipmentSlot = __Infer<typeof PlayerEquipmentSlot>;

export const PlayerLingerDespawns = __t.object("PlayerLingerDespawns", {
  playerId: __t.string(),
  scheduledAt: __t.timestamp(),
  despawnAt: __t.timestamp(),
});
export type PlayerLingerDespawns = __Infer<typeof PlayerLingerDespawns>;

export const PlayerMapData = __t.object("PlayerMapData", {
  playerId: __t.string(),
  displayName: __t.string(),
  guildName: __t.option(__t.string()),
  level: __t.u32(),
  currentInstanceId: __t.string(),
  currentMapId: __t.string(),
  mapX: __t.i32(),
  mapY: __t.i32(),
  prevMapX: __t.i32(),
  prevMapY: __t.i32(),
  rotation: __t.i16(),
  hp: __t.i32(),
  maxHp: __t.i32(),
  mana: __t.i32(),
  maxMana: __t.i32(),
  stamina: __t.i32(),
  maxStamina: __t.i32(),
  statusJson: __t.string(),
  isOnline: __t.bool(),
  updatedAt: __t.timestamp(),
});
export type PlayerMapData = __Infer<typeof PlayerMapData>;

export const PlayerRuntime = __t.object("PlayerRuntime", {
  playerId: __t.string(),
  currentInstanceId: __t.string(),
  currentMapId: __t.string(),
  updatedAt: __t.timestamp(),
});
export type PlayerRuntime = __Infer<typeof PlayerRuntime>;

export const PlayerRuntimeEquipment = __t.object("PlayerRuntimeEquipment", {
  runtimeSlotId: __t.string(),
  playerId: __t.string(),
  slotName: __t.string(),
  itemId: __t.string(),
  tradeable: __t.bool(),
  metadataJson: __t.string(),
  equippedAt: __t.timestamp(),
});
export type PlayerRuntimeEquipment = __Infer<typeof PlayerRuntimeEquipment>;

export const PlayerSkill = __t.object("PlayerSkill", {
  id: __t.string(),
  entityId: __t.string(),
  skillId: __t.string(),
  lastUsedTick: __t.i64(),
});
export type PlayerSkill = __Infer<typeof PlayerSkill>;

export const Players = __t.object("Players", {
  playerId: __t.string(),
  accountId: __t.string(),
  displayName: __t.string(),
  isOnline: __t.bool(),
  difficulty: __t.u8(),
  level: __t.u32(),
  xp: __t.u64(),
  currentInstanceId: __t.string(),
  currentMapId: __t.string(),
  mapX: __t.i32(),
  mapY: __t.i32(),
  rotation: __t.i16(),
  inventoryCapacity: __t.u32(),
  storageCapacity: __t.u32(),
  equipmentInventoryIds: __t.array(__t.string()),
  viewRadius: __t.u32(),
  updatedAt: __t.timestamp(),
});
export type Players = __Infer<typeof Players>;

export const RegisterPlayerArgs = __t.object("RegisterPlayerArgs", {
  playerId: __t.string(),
  username: __t.string(),
  password: __t.string(),
  displayName: __t.option(__t.string()),
});
export type RegisterPlayerArgs = __Infer<typeof RegisterPlayerArgs>;

export const RemoveFromItemBarArgs = __t.object("RemoveFromItemBarArgs", {
  inventoryId: __t.string(),
});
export type RemoveFromItemBarArgs = __Infer<typeof RemoveFromItemBarArgs>;

export const RemoveNpcArgs = __t.object("RemoveNpcArgs", {
  mapId: __t.string(),
  worldX: __t.i32(),
  worldY: __t.i32(),
});
export type RemoveNpcArgs = __Infer<typeof RemoveNpcArgs>;

export const SecurityLog = __t.object("SecurityLog", {
  logId: __t.u64(),
  playerId: __t.string(),
  incidentType: __t.string(),
  description: __t.string(),
  timestamp: __t.timestamp(),
});
export type SecurityLog = __Infer<typeof SecurityLog>;

export const Sessions = __t.object("Sessions", {
  identity: __t.identity(),
  playerId: __t.string(),
  lastHeartbeatAt: __t.timestamp(),
});
export type Sessions = __Infer<typeof Sessions>;

export const SkillBar = __t.object("SkillBar", {
  playerId: __t.string(),
  skillsJson: __t.string(),
});
export type SkillBar = __Infer<typeof SkillBar>;

export const SkillDefinition = __t.object("SkillDefinition", {
  skillId: __t.string(),
  displayName: __t.string(),
  description: __t.string(),
  cooldownTicks: __t.i64(),
  staminaCost: __t.i32(),
  durationTicks: __t.i64(),
  castTimeTicks: __t.i64(),
  range: __t.i32(),
  damage: __t.i32(),
  radius: __t.i32(),
  emoji: __t.string(),
  inputsJson: __t.string(),
  tags: __t.array(__t.string()),
  metaChildrenJson: __t.string(),
});
export type SkillDefinition = __Infer<typeof SkillDefinition>;

export const SplitInventoryItemArgs = __t.object("SplitInventoryItemArgs", {
  inventoryId: __t.string(),
  splitQuantity: __t.u32(),
});
export type SplitInventoryItemArgs = __Infer<typeof SplitInventoryItemArgs>;

export const StatusEffect = __t.object("StatusEffect", {
  effectId: __t.string(),
  effectType: __t.string(),
  sourceId: __t.string(),
  targetId: __t.string(),
  skillId: __t.string(),
  damage: __t.i32(),
  expiresAtTick: __t.option(__t.i64()),
  hidden: __t.bool(),
});
export type StatusEffect = __Infer<typeof StatusEffect>;

export const StorageSlotView = __t.object("StorageSlotView", {
  storageId: __t.string(),
  slotIndex: __t.i32(),
  itemId: __t.string(),
  quantity: __t.u32(),
  tradeable: __t.bool(),
  capacity: __t.u32(),
  metadataJson: __t.string(),
});
export type StorageSlotView = __Infer<typeof StorageSlotView>;

export const TickResults = __t.object("TickResults", {
  tickId: __t.string(),
  instanceId: __t.string(),
  sequence: __t.u32(),
  eventsJson: __t.string(),
  entitiesSnapshotJson: __t.string(),
  hashChainPrev: __t.string(),
});
export type TickResults = __Infer<typeof TickResults>;

export const TradeInventoryViewRow = __t.object("TradeInventoryViewRow", {
  ownerPlayerId: __t.string(),
  itemId: __t.string(),
  quantity: __t.u32(),
  tradeable: __t.bool(),
  metadataJson: __t.string(),
});
export type TradeInventoryViewRow = __Infer<typeof TradeInventoryViewRow>;

export const TradeTargetSession = __t.object("TradeTargetSession", {
  initiatorPlayerId: __t.string(),
  targetPlayerId: __t.string(),
  updatedAt: __t.timestamp(),
});
export type TradeTargetSession = __Infer<typeof TradeTargetSession>;

export const UnequipItemArgs = __t.object("UnequipItemArgs", {
  slotName: __t.string(),
});
export type UnequipItemArgs = __Infer<typeof UnequipItemArgs>;

export const UpdatePlayerPositionArgs = __t.object("UpdatePlayerPositionArgs", {
  playerId: __t.string(),
  currentInstanceId: __t.string(),
  currentMapId: __t.string(),
  mapX: __t.i32(),
  mapY: __t.i32(),
  rotation: __t.i16(),
  statusJson: __t.string(),
});
export type UpdatePlayerPositionArgs = __Infer<typeof UpdatePlayerPositionArgs>;

export const UseItemOnTileArgs = __t.object("UseItemOnTileArgs", {
  inventoryId: __t.string(),
  x: __t.i32(),
  y: __t.i32(),
});
export type UseItemOnTileArgs = __Infer<typeof UseItemOnTileArgs>;

export const UserCredentials = __t.object("UserCredentials", {
  username: __t.string(),
  passwordHash: __t.string(),
  playerId: __t.string(),
});
export type UserCredentials = __Infer<typeof UserCredentials>;

export const VisibleActorInventoryView = __t.object("VisibleActorInventoryView", {
  actorId: __t.string(),
  ownerKind: __t.string(),
  slotIndex: __t.i32(),
  itemId: __t.string(),
  quantity: __t.u32(),
  metadataJson: __t.string(),
});
export type VisibleActorInventoryView = __Infer<typeof VisibleActorInventoryView>;

export const VisiblePlayerIdentityData = __t.object("VisiblePlayerIdentityData", {
  playerId: __t.string(),
  displayName: __t.string(),
  guildName: __t.option(__t.string()),
});
export type VisiblePlayerIdentityData = __Infer<typeof VisiblePlayerIdentityData>;

